import React, { useRef, useState } from "react";
import { Input } from "./ui/input";
import { X, Move, Shield, MapPin } from "lucide-react";

const numInput =
  "h-8 px-2 border border-[#A8C97D] rounded-none text-sm font-mono-data focus:border-[#0EA5E9] focus:outline-none w-full";
const lbl = "text-[10px] uppercase tracking-wide text-zinc-500";

// Floating panel to configure a guard point before placing it on the map.
export default function GuardPanel({ config, onChange, onClose }) {
  const initX = typeof window !== "undefined" ? window.innerWidth - 360 : 600;
  const [pos, setPos] = useState({ x: initX, y: 90 });
  const drag = useRef(null);

  const onHeaderDown = (e) => {
    drag.current = { sx: e.clientX, sy: e.clientY, ox: pos.x, oy: pos.y };
    const move = (ev) =>
      setPos({ x: drag.current.ox + (ev.clientX - drag.current.sx), y: drag.current.oy + (ev.clientY - drag.current.sy) });
    const up = () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  };

  const set = (patch) => onChange({ ...config, ...patch });
  const numField = (key, label, testid) => (
    <label className="flex flex-col gap-0.5">
      <span className={lbl}>{label}</span>
      <input data-testid={testid} type="number" min="0" step="1" value={config[key] ?? 0} className={numInput}
        onChange={(e) => set({ [key]: parseInt(e.target.value) || 0 })} />
    </label>
  );

  return (
    <div
      data-testid="guard-panel"
      style={{ position: "fixed", left: pos.x, top: pos.y, width: 320, zIndex: 50 }}
      className="bg-white border-2 border-[#0EA5E9] shadow-2xl"
    >
      <div onPointerDown={onHeaderDown} data-testid="guard-panel-header"
        className="flex items-center justify-between px-3 h-10 bg-[#0EA5E9] text-white cursor-move select-none">
        <span className="flex items-center gap-2 font-head text-sm font-bold">
          <Shield size={14} strokeWidth={2} /> Punct pază
        </span>
        <button onClick={onClose} data-testid="guard-panel-close" className="hover:opacity-70">
          <X size={16} strokeWidth={2} />
        </button>
      </div>

      <div className="p-3 space-y-3">
        <label className="flex flex-col gap-0.5">
          <span className={lbl}>Nume</span>
          <Input data-testid="guard-name" value={config.name}
            onChange={(e) => set({ name: e.target.value })}
            className="h-8 rounded-none border-[#A8C97D] text-sm" />
        </label>

        <div className="grid grid-cols-4 gap-2">
          {numField("agents_setup", "Set-up", "guard-agents-setup")}
          {numField("agents_day", "Zi", "guard-agents-day")}
          {numField("agents_event", "Event", "guard-agents-event")}
          {numField("agents_night", "Noapte", "guard-agents-night")}
        </div>
        <p className="text-[11px] text-zinc-500">Număr de agenți pe fiecare regim.</p>

        <div className="flex items-center gap-2 text-xs text-[#0369A1] bg-[#0EA5E9]/10 px-2 py-2 font-medium">
          <MapPin size={14} strokeWidth={2} /> Click pe hartă pentru a amplasa punctul
        </div>
      </div>
    </div>
  );
}
